import React from 'react';
import Header from '../components/layout/header';
import './home.css'
import Footer from '../components/layout/footer';
import Sec5 from '../components/layout/section5';
import Sec7 from '../components/layout/section7';
import Sec6 from '../components/layout/section6';
const Projects = () => {
    return ( <><body className='bodyyy'>
    <main>
    <Header />


<Sec5 />
<Sec6 />
<Sec7 />
<Footer />
    </main>
</body>
    </> );
}
 
export default Projects;


